import React from 'react';
import MultiLines from './MultiLines';

interface Props {
    name: string,
    value?: string,
    bgcolor?:boolean,
}

const ColData:React.FC<Props> = (props)=> {
    let styleName = {backgroundColor:"#EEEEEE",padding:"0 0.5em",fontWeight:400};
    let styleValue = {padding:"0.5em",marginBottom:"1em"};
    if( props.bgcolor===false ){
        styleName = {backgroundColor:"#FFFFFF",padding:"0",fontWeight:700};
        styleValue = {padding:"0em 0",marginBottom:"1em"};    
    }
	return (
        <div>
            <div style={styleName}>{props.name}</div>
            <div style={styleValue}>
                {props.value &&
                <MultiLines text={props.value}/>
                }
            </div>
        </div>
    );
}

export default ColData;
